module.exports = __webpack_public_path__ + "static/media/manometer.4aab7fe2.jpg";